import React from 'react';
import RHSearchResult from '@components/search/search-result/rh-search-result';
import styled from '@emotion/styled/macro';
import Translate from '@utils/translation-functions';
import vars from '@variables';
import { InfiniteHits } from 'react-instantsearch';
import {
  ResultsBlockProps,
  InfiniteHitsTranslationsProps,
} from './results-block.types';

const ResultsBlock: React.FC<ResultsBlockProps> = ({ className }) => {
  const translations: InfiniteHitsTranslationsProps = {
    showPreviousButtonText: Translate('Load previous', true),
    showMoreButtonText: Translate('Load more', true),
  };
  return (
    <div className={className}>
      <InfiniteHits
        hitComponent={RHSearchResult}
        translations={translations}
        showPrevious={false}
      />
    </div>
  );
};

const StyledResultsBlock = styled(ResultsBlock)`
  .ais-InfiniteHits {
    margin-left: -${vars.spacingL};
    margin-right: -${vars.spacingL};
    .ais-InfiniteHits-list {
      width: 100%;
    }

    .ais-InfiniteHits-item {
      margin: 0;
      font-weight: ${vars.fontWeightRegular};
      width: 100%;
      a {
        width: 100%;
      }
      flex-grow: 1;
    }

    .ais-InfiniteHits-loadMore {
      margin: ${vars.spacingL} auto ${vars.spacingS} auto;
    }
  }
`;

export default StyledResultsBlock;
